import { useState } from 'react'

import { LaptopHelperButton } from './Button/LaptopHelperButton'
import { LaptopHelperNavigation } from './Navigation/LaptopHelperNavigation'
import { useShouldShowLaptopHelper } from './useShouldShowLaptopHelper'

export const LaptopHelper = () => {
  const shouldShowLaptopHelper = useShouldShowLaptopHelper()
  const [laptopHelperOpen, setLaptopHelperOpen] = useState(false)

  const handleOpenLaptopHelper = () => {
    setLaptopHelperOpen(true)
  }

  const handleLaptopHelperClose = () => {
    setLaptopHelperOpen(false)
  }

  if (!shouldShowLaptopHelper) {
    return null
  }

  return laptopHelperOpen ? (
    <LaptopHelperNavigation handleClose={handleLaptopHelperClose} />
  ) : (
    <LaptopHelperButton onClick={handleOpenLaptopHelper} />
  )
}
